import React from "react";
import { FaBell, FaMobileAlt, FaBookmark, FaMapMarkerAlt, FaBriefcase } from "react-icons/fa";
import BrandWordmark from "../../Common/BrandWordmark";
import { PLAY_STORE_URL } from "../../../constants/appLinks";
import { GOOGLE_PLAY_BADGE } from "../../../constants/appImages";
import "./GetAppSection.css";

const features = [
  {
    icon: FaBell,
    title: "Instant job alerts",
    text: "Get notified when roles match your profile.",
  },
  {
    icon: FaMobileAlt,
    title: "Apply on the go",
    text: "Browse and apply from anywhere, anytime.",
  },
  {
    icon: FaBookmark,
    title: "Save & track jobs",
    text: "Keep favourites and applications in one place.",
  },
];

const previewJobs = [
  {
    title: "Senior CA — Audit",
    company: "Deloitte India",
    location: "Mumbai",
    tag: "Full-time",
  },
  {
    title: "CS — Compliance Lead",
    company: "Tata Group",
    location: "Bangalore",
    tag: "Hybrid",
  },
  {
    title: "CMA — FP&A Analyst",
    company: "HDFC Bank",
    location: "Delhi NCR",
    tag: "On-site",
  },
];

const GetAppSection = () => {
  return (
    <section className="get-app-section" aria-label="Download CAJobPortal app">
      <div className="get-app-container">
        <div className="get-app-layout">
          <div className="get-app-copy">
            <span className="get-app-eyebrow">Now on Google Play</span>
            <h2 className="get-app-title">Download CAJobPortal app</h2>
            <p className="get-app-subtitle">
              Search CA, CS &amp; CMA jobs, receive alerts, and manage applications
              — all from your phone.
            </p>

            <ul className="get-app-features">
              {features.map(({ icon: Icon, title, text }) => (
                <li key={title} className="get-app-feature">
                  <span className="get-app-feature-icon" aria-hidden="true">
                    <Icon />
                  </span>
                  <div>
                    <strong>{title}</strong>
                    <p>{text}</p>
                  </div>
                </li>
              ))}
            </ul>

            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="get-app-play-link"
              aria-label="Get CAJobPortal on Google Play"
            >
              <img
                src={GOOGLE_PLAY_BADGE}
                alt="Get it on Google Play"
                className="get-app-play-badge"
                loading="lazy"
              />
            </a>
          </div>

          <div className="get-app-visual" aria-hidden="true">
            <div className="get-app-orbit get-app-orbit--one" />
            <div className="get-app-orbit get-app-orbit--two" />

            <div className="get-app-float-card get-app-float-card--alert">
              <span className="get-app-float-icon get-app-float-icon--bell">
                <FaBell />
              </span>
              <div>
                <strong>New job match</strong>
                <p>Senior CA — Mumbai</p>
              </div>
            </div>

            <div className="get-app-float-card get-app-float-card--stat">
              <span className="get-app-float-stat">2500+</span>
              <span className="get-app-float-label">Active jobs</span>
            </div>

            <div className="get-app-device">
              <div className="get-app-device-btn get-app-device-btn--power" />
              <div className="get-app-device-btn get-app-device-btn--vol-up" />
              <div className="get-app-device-btn get-app-device-btn--vol-down" />

              <div className="get-app-phone">
                <div className="get-app-phone-island">
                  <span className="get-app-phone-camera" />
                </div>

                <div className="get-app-phone-screen">
                  <div className="get-app-ui-status">
                    <span>9:41</span>
                    <div className="get-app-ui-signal">
                      <span /><span /><span /><span />
                    </div>
                  </div>

                  <div className="get-app-ui-header">
                    <div className="get-app-ui-brand-wrap">
                      <BrandWordmark variant="mini" />
                    </div>
                    <span className="get-app-ui-notif">
                      <FaBell />
                      <em>3</em>
                    </span>
                  </div>

                  <div className="get-app-ui-search">
                    <FaBriefcase aria-hidden="true" />
                    <span>Search CA, CS, CMA jobs…</span>
                  </div>

                  <div className="get-app-ui-jobs">
                    {previewJobs.map((job) => (
                      <article key={job.title} className="get-app-ui-job">
                        <div className="get-app-ui-job-top">
                          <h3>{job.title}</h3>
                          <span>{job.tag}</span>
                        </div>
                        <p className="get-app-ui-company">{job.company}</p>
                        <p className="get-app-ui-location">
                          <FaMapMarkerAlt aria-hidden="true" />
                          {job.location}
                        </p>
                      </article>
                    ))}
                  </div>

                  <div className="get-app-ui-nav">
                    <span className="is-active" />
                    <span />
                    <span />
                    <span />
                  </div>
                </div>

                <div className="get-app-phone-shine" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetAppSection;
